import { useGetData } from "../../../hooks/useGetData";
import type { Securities } from "./interfaces/Securities";
import { SecuritiesService } from "./SecuritiesService";

export interface Options {
	text: string;
	offset: number;
	limit: number;
	signal?: AbortSignal;
}

export class UseData {
	private constructor(private service: SecuritiesService) {}

	private static instance: UseData;

	static create() {
		if (!UseData.instance) {
			UseData.instance = new UseData(SecuritiesService.create());
		}
		return UseData.instance;
	}

	getData = async ({
		text,
		offset,
		limit,
	}: Readonly<Options>): Promise<Securities> => {
		return await this.service.getData(text, offset, limit);
	};

	useGetData = () => useGetData<Securities, Readonly<Options>>(this.getData);
}
